<script>
    import { Chip, Typography } from '$lib/components/UI'
    import { createEventDispatcher } from 'svelte'
    import picker from '../../../../src/assets/picker.svg'
    export let i = 0
    export let data = {}
    const dispatch = createEventDispatcher()
    function onClick() {
        dispatch('click')
    }
    $: desc = `${data.calle} ${data.numero}`
    $: active = data?.activa ?? true
</script>

<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<div class="employe" on:click={onClick} on:keypress={onClick} tabindex={i + 1}>
    <Chip
        style="position: absolute; bottom: 25px; right: 25px"
        color={active ? '#437F4F' : '#E9573D'}
        label={active ? 'Activa' : 'Inactiva'}
    />
    <span>
        <div class="avatar" style="background-image: url({picker})"></div>
    </span>
    <span class="title" title={desc}>
        <Typography style="margin: 0; padding: 0" type="h4"
            >{data?.nombre}</Typography
        >
        <Typography color="grey-400" style="margin: 0; padding: 0" type="h5"
            >{desc}</Typography
        >
    </span>
</div>

<style>
    .avatar {
        width: 64px;
        height: 64px;
        display: block;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .employe {
        user-select: none;
        gap: 15px;
        display: flex;
        min-width: 375px;
        max-width: 400px;
        width: auto;

        cursor: pointer;
        height: 115px;
        background: white;
        box-shadow: var(--shadow-default);
        position: relative;
        border-radius: 9px;
        padding: 25px;
    }
    .employe span {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 5px;
    }
</style>
